export const DOUBLE_CLICK_WINDOW_MS = 300;

export interface SingleClickGate {
  click: (action: () => void) => void;
  cancel: () => void;
}

// A double-click delivers two clicks before its dblclick, so a click only acts once the window closes without a second one.
export const createSingleClickGate = (windowMs: number = DOUBLE_CLICK_WINDOW_MS): SingleClickGate => {
  let pending: ReturnType<typeof setTimeout> | undefined;

  const cancel = () => {
    if (pending === undefined) return;
    clearTimeout(pending);
    pending = undefined;
  };

  const click = (action: () => void) => {
    if (pending !== undefined) {
      cancel();
      return;
    }
    pending = setTimeout(() => {
      pending = undefined;
      action();
    }, windowMs);
  };

  return { click, cancel };
};
